@if (company_product(); as product) {
  <div class="company-product-identity">
    <img [src]="product.logo_url || '/img/default-company_product.png'" [alt]="product.title" />
    <span>{{ product.title }}</span>
  </div>
}
